import { render, staticRenderFns } from "./WeeklyAgenda.vue?vue&type=template&id=6d09269e&"
import script from "./WeeklyAgenda.vue?vue&type=script&lang=js&"
export * from "./WeeklyAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports